'use strict';

(function() {
	angular.module('dat.shared-components.company')
		.directive('datCompanyDetail', datCompanyDetail);

	datCompanyDetail.$inject = ['CompanyService', '$log', 'eventNameService'];

	var companyService, $log, eventNameService;

	function datCompanyDetail(_companyService_, _$log_, _eventNameService_) {
		companyService = _companyService_; $log = _$log_; eventNameService = _eventNameService_;

		return {
			scope: {
				companyDetails: '=',
				searchType: '=',
				canPreferOrBlock: '@'
			},
			templateUrl: '/app/shared-components/company/company-detail.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope) {
		activate();

		//////////////////////////////////////////

		function activate() {
			scope.allowPreferOrBlock = scope.$eval(scope.canPreferOrBlock);
			$log.debug('datCompanyDetail activate, allowPreferOrBlock = ' + scope.allowPreferOrBlock.toString());
			scope.toggleModal = toggleModal;
			scope.clickPreferred = clickPreferred;
			scope.clickBlocked = clickBlocked;
		}

		function toggleModal() {
			$log.debug('company detail: toggleModal()');
			scope.$emit(eventNameService.companyDetail.modalClosed);
		}

		function clickPreferred() {
			$log.debug('Clicked preferred input. Current office filter = ' + scope.companyDetails.officeFilter);
			addOrRemoveOfficeFilter('Preferred');
		}

		function clickBlocked() {
			$log.debug('Clicked blocked input. Current office filter = ' + scope.companyDetails.officeFilter);
			addOrRemoveOfficeFilter('Blocked');
		}

		function addOrRemoveOfficeFilter(officeFilterAction) {
			if (scope.companyDetails.officeFilter) {
				$log.debug('Remove ' + officeFilterAction + ' for company ' + scope.companyDetails.combinedOfficeId);
				companyService.removeOfficeFilter(scope.companyDetails.combinedOfficeId).then(function () {
					scope.companyDetails.officeFilter = '';
					scope.$emit(eventNameService.companyDetail.removedOfficeFilter);
				});
			}
			else {
				$log.debug('Add ' + officeFilterAction + ' for company ' + scope.companyDetails.combinedOfficeId);
				companyService.addOfficeFilter(scope.companyDetails.combinedOfficeId, officeFilterAction).then(function () {
					scope.companyDetails.officeFilter = officeFilterAction;
					scope.$emit(eventNameService.companyDetail.addedOfficeFilter, officeFilterAction);
				});
			}
		}

	}
})();
